import Vue from 'vue'
import TurbolinksAdapter from 'vue-turbolinks'

document.addEventListener('turbolinks:load', () => {
  const el = document.querySelector('.vue-message-box')
  const TIME_OUT = 3000
  if (el) {
    const alert = new Vue({
      el,
      mixins: [TurbolinksAdapter],
      data: {
        visible: true
      },
      mounted() {
        setTimeout(() => (this.visible = false), TIME_OUT)
      }
    })
  }
})



// WEBPACK FOOTER //
// ./app/javascript/packs/components/message_box.js